
        if (import.meta.env.DEV) {
            // Shut up, Wesley.
            const c = `Lit is in dev mode. Not recommended for production! See https://lit.dev/msg/dev-mode for more information.`;
            window.litIssuedWarnings = new Set();
            litIssuedWarnings.add(c);
        }

        import "./src/button-bar";
        import "./src/button";
        import "./src/checkbox";
        import "./src/combo-box";
        import "./src/combo-box-item";
        import "./src/divider";
        import "./src/dropdown";
        import "./src/floater";
        import "./src/icon";
        import "./src/layout";
        import "./src/menu";
        import "./src/menu-item";
        import "./src/options-layout";
        import "./src/radio";
        import "./src/radio-group";
        import "./src/range";
        import "./src/spinner";
        import "./src/tab";
        import "./src/tab-panel";
        import "./src/tab-stack";

        const oldClick = HTMLButtonElement.prototype.connectedCallback;
        HTMLButtonElement.prototype.connectedCallback = function () {
            oldClick.call(this);
            console.log("connected callback");
        };

        window.onload = () => {
            const brightSide = document.body.firstElementChild.cloneNode(true);
            brightSide.dataset.theme = "light";
            document.body.append(brightSide);
            document.body.style.opacity = "1";
        };
    